<div *transloco="let tloco; prefix: 'subscriptions.my-subscription'" class="h-full rounded-md border border-steel-20">
  <div class="flex flex-col gap-y-6 p-3 md:p-6">
    <div class="flex gap-x-2">
      @if (platformIcon) {
        <rma-icon [glyph]="platformIcon" />
      }
      <span class="text-button md:mb-4">{{ tloco('insights-' + platform | lowercase) }}</span>
    </div>
    <div class="flex">
      <rma-stat-block
        class="flex w-1/2 flex-col"
        [blurb]="tloco('insights-reviews', { count: $safeNavigationMigration(reviewInfo?.convertedReviews) })"
        [value]="reviewInfo?.convertedReviews ?? 0"
      />
      <rma-stat-block
        class="flex w-1/2 flex-col"
        [blurb]="tloco('insights-exposures', { count: $safeNavigationMigration(reviewInfo?.totalExposures) })"
        [value]="reviewInfo?.totalExposures ?? 0"
      />
    </div>
    <p class="italic">{{ tloco('insights-info-' + platform.toLowerCase(), { count: $safeNavigationMigration(reviewInfo?.convertedReviews) }) }}</p>
  </div>
</div>
